// extracted by mini-css-extract-plugin
export default {"root":"status-badges_root__HSpZk"};